import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

/** One of the invoice email templates, shared by every user. */
export interface EmailTemplate {
  emailTemplateId: number
  name: string
  subject: string
  body: string
  /** What a new invoice starts on. */
  isDefault: boolean
  updatedDate: string | null
  updatedBy: string | null
  /** How many invoices are set to be emailed with it. */
  invoiceCount: number
}

export interface EmailTemplateList {
  templates: EmailTemplate[]
  /** Placeholder, e.g. {InvoiceNumber}, to what it becomes. */
  placeholders: Record<string, string>
}

export interface EmailTemplateForm {
  name: string
  subject: string
  body: string
  isDefault: boolean
}

const headers = () => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  }
}

export const getInvoiceEmailTemplates = async (): Promise<EmailTemplateList> => {
  const response = await axios.get(`https://${apiURL}/EmailTemplate/Invoice`, { headers: headers() })
  return response.data
}

export const createInvoiceEmailTemplate = async (form: EmailTemplateForm): Promise<EmailTemplate> => {
  const response = await axios.post(`https://${apiURL}/EmailTemplate/Invoice`, form, { headers: headers() })
  return response.data
}

export const updateInvoiceEmailTemplate = async (id: number, form: EmailTemplateForm): Promise<EmailTemplate> => {
  const response = await axios.put(`https://${apiURL}/EmailTemplate/Invoice/${id}`, form, { headers: headers() })
  return response.data
}

/** Retires it: no longer offered, but invoices already on it keep it. */
export const deleteInvoiceEmailTemplate = async (id: number): Promise<void> => {
  await axios.delete(`https://${apiURL}/EmailTemplate/Invoice/${id}`, { headers: headers() })
}
